<template>
  <footer class="container-site-padding">
    <div class="site-map">
      <div class="footer-menu">
        <div
          class="list"
          data-aos="slide-in-bck-center"
          data-aos-duration="500"
        >
          <p class="text-uppercase">Poznaj Eclipse Cross PHEV</p>
          <ul>
            <li>
              <router-link to="/car-drive">Napęd</router-link>
            </li>
            <li>
              <router-link to="/drive-control">Kontrola Jazdy</router-link>
            </li>
            <li>
              <p @click="carSlider.showDialog = true">Widok 360</p>
            </li>
            <li>
              <router-link to="/safety">Bezpieczeństwo</router-link>
            </li>
            <li>
              <router-link to="/audio">Multimedia</router-link>
            </li>
            <li>
              <router-link to="/interior">Wyposażenie wnętrza</router-link>
            </li>
          </ul>
        </div>
        <div
          class="list"
          data-aos="slide-in-bck-center"
          data-aos-duration="500"
          data-aos-delay="150"
        >
          <p class="text-uppercase">Wersje wyposażenia</p>
          <ul>
            <li :key="version" v-for="version in this.carVersions">
              <p @click="goToHome('versions', '/#versions')">{{ version }}</p>
            </li>
          </ul>
        </div>
        <div
          class="list"
          data-aos="slide-in-bck-center"
          data-aos-duration="500"
          data-aos-delay="300"
        >
          <p class="text-uppercase">Specyfikacja techniczna</p>
          <ul>
            <li>
              <a
                href="https://www.mitsubishi.pl/storage/file/core_files/2021/8/17/7a097665ada292c027850681cb59209e/katalog_mitsubishi_eclipse_cross_phev_my21_prev-1-17082021.pdf"
                target="_blank"
                >Dane technincze</a
              >
            </li>
          </ul>
        </div>
        <div
          class="list"
          data-aos="slide-in-bck-center"
          data-aos-duration="500"
          data-aos-delay="450"
        >
          <p class="text-uppercase">Kontakt</p>
          <ul>
            <li>
              <!--<a @click="form.showDialog = true">Kontakt on-line</a>-->
              <a
                href="https://www.mitsubishi.pl/oferta/eclipse-cross-phev"
                target="_blank"
                >Aktualne promocje</a
              >
            </li>
            <li>
              <a href="https://www.mitsubishi.pl/polityka-prywatnosci"
                >Polityka prywatności</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="footer-info">
        <div class="socials text-left">
          <a
            href="https://www.youtube.com/user/MitsubishiMotorsPL"
            data-aos="flip-down"
            data-aos-duration="500"
          >
            <img src="../assets/images/icon-youtube.png" alt="YouTube" />
          </a>
          <a
            href="https://www.facebook.com/MitsubishiMotorsPolska/?fref=ts"
            data-aos="flip-down"
            data-aos-duration="500"
            data-aos-delay="150"
          >
            <img src="../assets/images/icon-facebook.png" alt="Facebook" />
          </a>
        </div>
        <div
          class="company text-right"
          data-aos="slide-left"
          data-aos-duration="500"
        >
          <p>
            Astara Poland Sp. z o.o.
            <br />
            ul. Cybernetyki 10
            <br />
            02-677 Warszawa
          </p>
        </div>
        <div class="logo text-right">
          <div>
            <v-btn
              :class="'mmc-red background'"
              v-ripple="{ class: 'ripple-red' }"
              href="https://www.mitsubishi.pl/oferta/eclipse-cross-phev"
              data-aos="zoom-in"
              data-aos-duration="500"
            >
              Aktualne promocje
            </v-btn>
            <!--
            <v-btn
              :class="'mmc-red background'"
              v-ripple="{ class: 'ripple-red' }"
              @click="form.showDialog = true"
              data-aos="zoom-in"
              data-aos-duration="500"
            >
              Kontakt on-line
            </v-btn>
            -->
            <!--<v-btn
                :class="'mmc-red background text-center'"
                data-aos="bounceIn"
                data-aos-duration="500"
                href="https://www.mitsubishi.pl/storage/file/core_files/2021/8/17/7a097665ada292c027850681cb59209e/katalog_mitsubishi_eclipse_cross_phev_my21_prev-1-17082021.pdf"
                v-ripple="{ class: 'ripple-red' }"
                >{{ this.home.text.specButton }}
            </v-btn>-->
          </div>
          <a href="#" @click="goToHome('home', '/')">
            <img
              src="../assets/images/logo-ec-phev.png"
              alt="Outlander Phev"
              data-aos="fade-up"
              data-aos-duration="500"
            />
          </a>
          <a href="#" @click="goToHome('home', '/')">
            <img
              src="../assets/images/logo-mitsubishi.png"
              alt="Mitsubishi"
              data-aos="fade-up"
              data-aos-duration="500"
              data-aos-delay="150"
            />
          </a>
          <img
            class="icon"
            src="../assets/images/8_lat_gwarancji.png"
            alt="8 lat gwarancji"
            data-aos="fade-up"
            data-aos-duration="500"
            data-aos-delay="300"
          />
          <img
            class="icon"
            src="../assets/images/piec_lat_gwarancji.jpg"
            alt="5 lat gwarancji"
            data-aos="fade-up"
            data-aos-duration="500"
            data-aos-delay="450"
          />
        </div>
      </div>
      <p class="copyright">
        Copyright 2022 by Mitsubishi-Motors. All rights reserved. Privacy
        policy.
      </p>
    </div>
  </footer>
</template>

<script>
import carVersions from "../data/car-versions.data";
import meetOutlander from "../data/meet-outlander.data";
import AOS from "aos";

import { mapGetters } from "vuex";

export default {
  name: "Footer",
  data: function() {
    return {
      carVersions: carVersions,
      meetOutlander: meetOutlander
    };
  },
  computed: {
    ...mapGetters({
      carSlider: "carSlider",
      form: "form"
    })
  },
  methods: {
    goToHome(link, path) {
      const home = document.querySelector(".home");

      if (home !== null) {
        const versions = document.querySelector(
          `li[data-menuanchor='${link}']`
        );
        versions.dispatchEvent(new Event("click"));
      } else {
        this.$router.push(`${path}`);
      }
    },
    refreshAos() {
      setTimeout(() => {
        AOS.refreshHard();
      }, 1000);
    }
  },
  mounted() {
    AOS.init({
      offset: 0,
      once: false,
      mirror: true,
      easing: "ease-in-out-sine"
    });

    window.addEventListener("resize", this.refreshAos);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.refreshAos);
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/mixins";

footer {
  position: relative;
  margin-bottom: var(--page-offset);
  overflow: hidden;

  .site-map {
    @include display-flex(flex, wrap);
    padding: var(--page-offset);
    background-color: $footer-background;
    min-height: calc(50vh - var(--page-offset));

    @media screen and (max-height: $screen-height-lg) {
      padding: 3.5rem var(--page-offset);
    }

    @media screen and (max-width: $screen-xxl) {
      padding: var(--page-offset);
    }

    @media screen and (max-height: 650px) {
      min-height: auto;
    }

    @media screen and (max-width: $screen-sm) {
      padding: var(--page-offset);
      min-height: auto;
    }

    .footer-menu {
      @include display-flex(flex, wrap);
      @include size-flex(70%);

      @media screen and (max-width: $screen-lg) {
        @include size-flex(65%);
      }

      @media screen and (max-width: $screen-sm) {
        @include size-flex(100%);
      }

      .list {
        @include size-flex(25%);
        padding-right: 1rem;

        @media screen and (max-width: $screen-sm) {
          @include size-flex(50%);
          margin-bottom: 1rem;
        }

        @media screen and (max-width: $screen-xs) {
          @include size-flex(100%);
        }

        p {
          @include font-size-weight(0.9rem, 500);
          margin-bottom: 2.5rem;

          @media screen and (max-width: $screen-xl) {
            margin-bottom: 1.5rem;
          }

          @media screen and (max-width: $screen-lg) {
            margin-bottom: 0.8rem;
            font-size: 0.8rem;
          }
        }

        ul {
          @include margin-padding(0, 0);
          list-style: none;

          li {
            margin-bottom: 1rem;

            @media screen and (max-width: $screen-xl) {
              margin-bottom: 0.5rem;
            }

            @media screen and (max-width: $screen-lg) {
              margin-bottom: 0.2rem;
            }

            &:hover {
              a,
              p {
                &::after {
                  width: 100%;
                }
              }
            }

            a,
            p {
              @include font-size-color(0.9rem, $mmc-gray);
              text-decoration: none;
              position: relative;

              &::after {
                @include set-position(absolute, auto, auto, 0, 0);
                @include set-size(0, 1px);
                content: "";
                background-color: $mmc-gray;
                transition: width 0.3s ease-in-out;
              }
            }

            p {
              display: inline-block;
              margin: 0;
              font-weight: 400;
              cursor: pointer;
            }
          }
        }
      }
    }

    .footer-info {
      @include display-flex(flex, wrap);
      @include size-flex(30%);

      @media screen and (max-width: $screen-lg) {
        @include size-flex(35%);
      }

      @media screen and (max-width: $screen-sm) {
        @include size-flex(100%);
        padding-top: var(--page-offset);
      }

      .socials {
        @include size-flex(30%);

        @media screen and (max-width: $screen-lg) {
          @include size-flex(20%);
        }

        @media screen and (max-width: $screen-md) {
          @include size-flex(30%);
        }

        @media screen and (max-width: $screen-xs) {
          @include size-flex(100%);
        }

        a {
          display: inline-block;
          margin-right: 1.2rem;

          &:last-of-type {
            margin-right: 0;
          }

          @media screen and (max-width: 1900px) {
            img {
              max-width: 2.5rem;
            }
          }

          @media screen and (max-width: $screen-xl) {
            margin-right: 0.6rem;

            img {
              max-width: 2.15rem;
            }
          }

          @media screen and (max-width: $screen-lg) {
            img {
              max-width: 1.25rem;
            }
          }

          @media screen and (max-width: $screen-sm) {
            img {
              max-width: 2.15rem;
            }
          }
        }
      }

      .company {
        @include size-flex(70%);

        @media screen and (max-width: $screen-lg) {
          @include size-flex(80%);
        }

        @media screen and (max-width: $screen-md) {
          @include size-flex(70%);
        }

        @media screen and (max-width: $screen-xs) {
          @include size-flex(100%);
          padding-top: var(--page-offset);
          text-align: left !important;
        }

        p {
          font-size: 1rem;

          @media screen and (max-width: $screen-lg) {
            font-size: 0.8rem;
          }
        }
      }

      .mmc-red {
        @include margin-padding(0 0 2rem, 1rem !important);
        width: auto;
        font-size: 1.25rem !important;
        max-width: 100%;
        text-align: center !important;

        @media screen and (max-width: $screen-xxl) {
          font-size: 1rem !important;
        }

        @media screen and (max-width: $screen-lg) {
          font-size: 0.8rem !important;
        }
      }

      .logo {
        @include size-flex(100%);
        align-self: flex-end;

        @media screen and (max-width: $screen-xs) {
          text-align: left !important;
        }

        a {
          margin-right: 1.9rem;

          @media screen and (max-width: $screen-xl) {
            margin-right: 1.15rem;
          }

          @media screen and (max-width: $screen-md) {
            margin-right: 0.5rem;
          }

          &:last-of-type {
            margin-right: 0;
          }
        }

        img {
          display: inline-block;
          vertical-align: middle;

          @media screen and (max-width: 2200px) {
            max-width: 5rem;
            max-height: 3rem;
          }

          &.icon {
            display: inline-block;
            max-width: 3rem;
            margin-left: 1rem;

            @media screen and (max-width: $screen-lg) {
              max-width: 2rem;
            }

            @media screen and (max-width: $screen-md) {
              margin-left: 0.5rem;
            }
          }
        }
      }
    }

    .copyright {
      @include set-position(
        absolute,
        auto,
        50%,
        calc(var(--page-offset) / 2 - 0.5rem),
        auto
      );
      @include font-size-color(0.75rem, $mmc-gray-dark);
      transform: translate(50%, -50%);
      margin: 0;

      @media screen and (max-width: $screen-md) {
        @include set-position(relative, auto, 0, 0, auto);
        @include size-flex(100%);
        transform: none;
        text-align: center;
        padding-top: var(--page-offset);
      }
    }
  }
}
</style>
